const HtmlInstruction = () => {
  return (
    <div className="instructions">
     <p>1. Copy the code provided.
</p>
<p>2. Paste it where you want the form to appear in your HTML.</p>
    </div>
  );
};

export default HtmlInstruction;
